
export default function Features() {
  const features = [
    {
      icon: 'ri-calendar-line',
      title: 'Personalized Weekly Plans',
      description: 'Custom training schedules designed specifically for your goals and fitness level'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Custom Mileage & Workouts',
      description: 'Structured progression that adapts to your improvement and recovery needs'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Strength + Mobility',
      description: 'Complementary exercises to keep you injury-free and performing at your best'
    },
    {
      icon: 'ri-chat-check-line',
      title: 'Monthly Check-ins',
      description: 'Regular progress reviews to ensure you\'re on track and feeling strong'
    },
    {
      icon: 'ri-message-3-line',
      title: 'Easy Communication',
      description: 'Direct access to your coach for questions, adjustments, and support'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Plan Adjustments',
      description: 'Flexible modifications based on how you\'re feeling and responding to training'
    }
  ];

  return (
    <section id="features" className="py-24 bg-[#F5F5F3]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">What You Get</h2>
        <p className="text-lg text-gray-600 mb-16 max-w-3xl">
          Whether you're training for your first 5k or chasing a half marathon PR, PACED Coaching gives you structure, accountability, and smart progression.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-[#E8744F]`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-2xl font-bold text-[#E8744F]">All for $50/month.</p>
        </div>
      </div>
    </section>
  );
}
